
export class Authentication {

  userName: string = '';
  token: string = '';
  internalUser: boolean = false;
  clientName: string = '';
  countryCodes: Array<string> = [];
}
